// 스타일
import './view.scss';

// 스크립트
import './assets/script/theme.js'
import './assets/parts/footer/style.js'
import './assets/parts/header/style.js'
import './assets/parts/navigation/style.js'
import './assets/parts/search-overlay/style.js'
import './assets/parts/sidebar/style.js'
import './assets/parts/single-post/style.js'
import './assets/lib/aos/init.js'
import './assets/lib/typing/init.js'
import './assets/lib/mask/init.js'
import './assets/lib/count/init.js'
import './assets/lib/accordion/init.js'
import './assets/lib/tabs/init.js'
import './assets/lib/sticky/init.js'
import './assets/lib/share/init.js'
import './assets/lib/overlay/init.js'

// 슬라이더
import './assets/lib/swiper/init.js'

// 실행
import './assets/script/init.js'